(() => {

    const urlPrefix = window.TLRAPP && window.TLRAPP.UrlPrefix ? window.TLRAPP.UrlPrefix : '';
    const clientId = window.TLRAPP && window.TLRAPP.AppName ? window.TLRAPP.AppName : 'my';
    const OIDC_CONFIG = {

            persistKey: 'tlrApp',
            authority: 'https://' + urlPrefix + 'accounts.'+window.TLRAPP.DomainName+'/core',
            client_id: clientId + '.tillr.client',
            redirect_uri: window.location.protocol + '//' + window.location.host + '/',
            // post_logout_redirect_uri: window.location.protocol + '//' + window.location.host + '/',
            response_type: 'id_token token',
            scope: 'openid profile email roles tenantProfile moduleId api userId',
            silent_redirect_uri:   window.location.protocol + '//' + window.location.host + '/silent_renew.html',
            silent_renew:   true,
            filter_protocol_claims: true,
            store: window.sessionStorage

    };

    window.TLRAPP = window.TLRAPP || {};
    window.TLRAPP.OIDC = window.TLRAPP.OIDC || {};
    window.TLRAPP.OIDC.Config = OIDC_CONFIG;

})();